
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternatives/aisensy",
      function () {
        return require("private-next-pages/alternatives/aisensy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternatives/aisensy"])
      });
    }
  